import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { apiEndpoints } from "../../config";
import { getEntityCategories } from "../../partials/posts/postHelpers";
import NestedCategory from "../../partials/nestedCategory";

import { Container, Col, Row } from "react-bootstrap";
import {
  Autocomplete,
  Dialog,
  Box,
  DialogContent,
  Button,
  Typography,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
  InputAdornment,
  IconButton,
  Input,
} from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";

import CompanyappLoader from "../../partials/companyappLoader";
import Pagination from "../../partials/pagination";

import DialogPaper from "../../partials/dialogPaper";
import { getOnlineNode } from "../../core/getNode";

const TYPES = [
  { typeName: "news", typeLabel: "News", targetVid: "news_categories" },
  { typeName: "event", typeLabel: "Events", targetVid: "event_categories" },
  {
    typeName: "presentation",
    typeLabel: "Presentations",
    targetVid: "presentation_categories",
  },
  { typeName: "video", typeLabel: "Videos", targetVid: "video_categories" },
  {
    typeName: "gallery",
    typeLabel: "Galleries",
    targetVid: "gallery_categories",
  },
  {
    typeName: "podcast",
    typeLabel: "Podcasts",
    targetVid: "podcast_categories",
  },
  {
    typeName: "document",
    typeLabel: "Documents",
    targetVid: "document_categories",
  },
  {
    typeName: "training",
    typeLabel: "Training Courses",
    targetVid: "training_categories",
  },
  { typeName: "quiz", typeLabel: "Quizzes", targetVid: "quiz_categories" },
  { typeName: "link", typeLabel: "Links", targetVid: "link_categories" },
];

const libraries = [
  {
    value: 0,
    label: "All Libraries",
  },
  {
    value: "user_library",
    label: "My Library",
  },
  {
    value: "shared_library",
    label: "Shared Library",
  },
  {
    value: "core_library",
    label: "Corporate Library",
  },
];

const input_font_size = 14;
const input_variant = "outlined";
const pageSize = 24;

export default function EntitySelector(props) {
  // const [showSelector, setShowSelector] = useState(false);
  const [selection, setSelection] = useState([]);
  const [selectedType, setSelectedType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [category, setCategory] = useState(0);
  const [language, setLanguage] = useState(0);
  const [author, setAuthor] = useState({
    label: "",
    value: "",
  });
  const [library, setLibrary] = useState(0);

  const [authors, setAuthors] = useState([]);
  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const user = useSelector((state) => state).authReducer.user;
  const getUsers = () => {
    getOnlineNode("users")
      .then((response) => {
        let users = [];
        response.data.forEach((item) => {
          users.push({
            value: item.uid,
            label: item.name,
          });
        });

        setAuthors(users);
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (props.currentBlock !== null) {
      setSelection(props.currentBlock?.data?.entities || []);
    } else {
      setSelection([]);
    }
  }, [props.currentBlock]);

  useEffect(() => {
    getContent();
  },[currentPage]);

  useEffect(() => {
    setIsLoading(true);
    getUsers();
    if (selectedType !== "all") {
      const selectedTypeObj = TYPES.find((t) => t.typeName === selectedType);
      if (selectedTypeObj) {
        getEntityCategories({
          user,
          setCategories,
          setLanguages,
          _setError,
          targetVid: selectedTypeObj.targetVid,
        });
        getContent();
      }
    }else {
      setIsLoading(false);
      getContent()
    }
    setCurrentPage(0);
    setResults([]);
    setCategory(0);
    setAuthor("");
    setLanguage(0);
    setLibrary(0);
  }, [selectedType]);

  const insertSelections = () => {
    if (props.insertSelections) {
      props.insertSelections(selection);
    }
  };

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  const _setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);

    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  const renderSearchFilters = () => {
    return (
      <>
        <Row className="entity-search-filter mb-4">
          <Col xs={6}>
            <TextField
              className="w-100"
              label="Search"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search entities..."
              InputProps={{
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchTerm("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Col>

          <Col xs={4}>
            <FormControl className="w-100" size="small">
              <InputLabel id="type-filter-label">Type</InputLabel>
              <Select
                labelId="type-filter-label"
                id="type-filter"
                value={selectedType}
                onChange={handleTypeChange}
                input={<OutlinedInput label="Type" />}
              >
                <MenuItem value="all">All</MenuItem>
                {TYPES.map((type, index) => (
                  <MenuItem
                    key={`type-${type.typeName}-${index}`}
                    value={type.typeName}
                  >
                    {type.typeLabel}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Col>
          <Col xs={2} className="d-flex gap-2">
            <Row>
              <Col xs={6}>
                <Button
                  className="w-100 h-100 entity-search-btn"
                  owner="admin"
                  variant="outlined"
                  dialogbtn="true"
                  dialogvariant="cancel"
                  onClick={resetFilters}
                >
                  <Typography owner="admin" variant="button">
                    Reset
                  </Typography>
                </Button>
              </Col>
              <Col xs={6}>
                <Button
                  className="w-100 h-100 entity-search-btn"
                  owner="admin"
                  variant="contained"
                  dialogbtn="true"
                  dialogvariant="primary"
                  onClick={() => {
                    setIsLoading(true);
                    getContent();
                  }}
                >
                  <Typography owner="admin" variant="button">
                    Search
                  </Typography>
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        {selectedType !== "all" && (
          <Row>
            <Col xs={3}>
              <NestedCategory
                categories={categories}
                title={"Categories"}
                categoryName={"categories"}
                selectedCategoryItem={category}
                handleCategorySelection={(value) => setCategory(value)}
              />
            </Col>
            <Col xs={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  ListboxProps={{
                    sx: { fontSize: input_font_size },
                  }}
                  options={authors}
                  getOptionLabel={(option) =>
                    option?.label ? option?.label : ""
                  }
                  value={author ? author : ""}
                  size="small"
                  freeSolo
                  onChange={(event, value) => {
                    if (value !== null) {
                      setAuthor(value);
                    } else {
                      setAuthor("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Author"
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                        style: {
                          fontSize: input_font_size,
                          paddingRight: "10px",
                        },
                        endAdornment: (
                          <InputAdornment position="start">
                            <SearchOutlined
                              sx={{
                                width: "20px",
                                height: "18px",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        style: { fontSize: input_font_size },
                      }}
                      owner="admin"
                      sub_variant="presentation-filter"
                    />
                  )}
                />
              </FormControl>
            </Col>
            <Col xs={3}>
              <FormControl
                fullWidth
                size="small"
                sx={{ backgroundColor: "primary.light" }}
              >
                <InputLabel
                  sx={{ fontSize: input_font_size, color: "primary.main" }}
                  size="small"
                  id="language-select-label"
                >
                  Language
                </InputLabel>
                <Select
                  labelId="language-select-label"
                  id="language-select"
                  value={language}
                  label="Language"
                  variant={input_variant}
                  onChange={(event) => {
                    setLanguage(event.target.value);
                  }}
                  input={
                    input_variant === "outlined" ? (
                      <OutlinedInput
                        owner="admin"
                        sub_variant="presentation-filter"
                        sx={{
                          fontSize: input_font_size,
                        }}
                        label="Language"
                      />
                    ) : (
                      <Input
                        sx={{ fontSize: input_font_size }}
                        label="Language"
                      />
                    )
                  }
                >
                  {languages?.map((language, index) => (
                    <MenuItem
                      key={`language-${index}`}
                      value={language.value}
                      sx={{ fontSize: input_font_size }}
                    >
                      {language.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
            <Col xs={3}>
              <FormControl
                fullWidth
                size="small"
                sx={{ backgroundColor: "primary.light" }}
              >
                <InputLabel
                  sx={{ fontSize: input_font_size, color: "primary.main" }}
                  size="small"
                  id="library-select-label"
                >
                  Library
                </InputLabel>
                <Select
                  labelId="library-select-label"
                  id="library-select"
                  value={library}
                  label="Library"
                  onChange={(event) => {
                    setLibrary(event.target.value);
                  }}
                  input={
                    input_variant === "outlined" ? (
                      <OutlinedInput
                        owner="admin"
                        sub_variant="presentation-filter"
                        sx={{
                          fontSize: input_font_size,
                        }}
                        label="Library"
                      />
                    ) : (
                      <Input
                        sx={{ fontSize: input_font_size }}
                        label="Library"
                      />
                    )
                  }
                >
                  {libraries.map((library, index) => (
                    <MenuItem
                      key={`library-${index}`}
                      value={library.value}
                      sx={{ fontSize: input_font_size }}
                    >
                      {library.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
          </Row>
        )}
      </>
    );
  };

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedType("all");
    setResults([]);
  };

  const handleSelect = (item) => {
    setSelection((prev) =>
      prev.some((s) => s.id === item.id)
        ? prev.filter((s) => s.id !== item.id)
        : [...prev, item],
    );
  };

  const entityItem = (item) => {
    const isSelected = selection.some((s) => s.id === item.id);

    return (
      <Col
        xs={2}
        key={`entity-${item.type}-${item.id}`}
        className={`entity-item${isSelected ? " selected" : ""}`}
        onClick={() => handleSelect(item)}
        style={{ cursor: "pointer" }}
      >
        <div className="entity-item-redactor d-flex flex-column w-100 h-100">
          <Row className="gx-0">
            <div className="entity-thumbnail-container ratio ratio-16x9">
              <img src={item.thumbnail} alt={`${item.title}-thumbnail`} />
            </div>
          </Row>
          <Row className="gx-0">
            <Typography
              className="entity-item-title"
              owner="admin"
              variant="h6"
            >
              {item.title}
            </Typography>
          </Row>
        </div>
      </Col>
    );
  };

  const renderItems = (items) => {
    return (
      <>
        {isLoading ? (
          <CompanyappLoader />
        ) : (
          <Row className="entity-items-container d-flex align-items-stretch">
            {items.map((item) => entityItem(item))}
          </Row>
        )}
      </>
    );
  };

  const getContent = () => {
    const params = new URLSearchParams();
    params.set("items_per_page", pageSize);
    params.set("page", currentPage);
    if (searchTerm) params.set("q", searchTerm);
    if (selectedType !== "all") params.set("types", selectedType);
    if (category !== 0) params.set("category", category);
    if (author !== "") params.set("uid", author.value);
    if (language !== 0) params.set("language", language);
    if (library !== 0) params.set("library", library);
    const queryString = params.toString();
    const path = `${apiEndpoints.entitySearch}?${queryString}`;


    getOnlineNode(path, user.access_token)
      .then((response) => {
        setResults(response.data.rows);
        setTotalItems(response.data.pager.total_items);
        setIsLoading(false);
      })
      .catch((_error) => {
        setIsLoading(false);
        console.error(_error);
      });
  };

  const renderSelections = () => {
    if (selection.length === 0) return null;

    return (
      <Box className="entity-selections mt-3">
        <Typography owner="admin" variant="h6" className="mb-2">
          Selected ({selection.length})
        </Typography>
        <Row className="d-flex align-items-stretch">
          {selection.map((item) => entityItem(item))}
        </Row>
      </Box>
    );
  };
  
    const renderPagination = () => {
      if (totalItems <= pageSize) {
        return null;
      } else {
        return (
          <Pagination
            owner="client"
            containerClasses={`entity-selector-pagination d-flex justify-content-center align-items-center mt-4`}
            previousDisabled={currentPage === 0 ? true : false}
            nextDisabled={results.length < pageSize ? true : false}
            currentPage={currentPage + 1}
            onPrevious={() => {
              setIsLoading(true);
              setCurrentPage(currentPage - 1);
            }}
            onNext={() => {
              setIsLoading(true);
              setCurrentPage(currentPage + 1);
            }}
          />
        );
      }
    };

  return (
    <>
      {/* <Button
        variant="contained"
        owner="admin"
        onClick={() => setShowSelector(true)}
      >
        <Typography owner="admin" variant="button">
          Select entities
        </Typography>
      </Button> */}
      <Dialog
        className="ps-modal entity-selector-modal"
        open={props.showSelector}
        maxWidth={"lg"}
        fullWidth={true}
        onClose={(event, reason) => {
          if (reason && reason === "backdropClick") return;
          props.setShowSelector(false);
        }}
        PaperComponent={DialogPaper}
      >
        <Box className="ps-modal-title dialog-draggable-handle">
          <Container fluid>
            <Row className="align-items-center">
              <Col xs={12} sm={6}>
                <Typography variant="h3" owner="admin" color="adminText.dark">
                  Resource Selector
                </Typography>
              </Col>
              <Col xs={12} sm={6}>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                >
                  <Button
                    variant="outlined"
                    owner="admin"
                    dialogbtn="true"
                    dialogvariant="cancel"
                    onClick={() => props.setShowSelector(false)}
                  >
                    <Typography variant="button" owner="admin" className="lh">
                      Cancel
                    </Typography>
                  </Button>
                  <Button
                    variant="contained"
                    owner="admin"
                    dialogbtn="true"
                    dialogvariant="save"
                    className="lh"
                    onClick={() => {
                      insertSelections();
                      props.setShowSelector(false);
                    }}
                  >
                    <Typography variant="button" owner="admin" className="lh">
                      Insert
                    </Typography>
                  </Button>
                </Stack>
              </Col>
            </Row>
          </Container>
        </Box>
        <DialogContent>
          <Box className="ps-modal-content">
            <Container>{renderSearchFilters()}</Container>
            <Container>{results && renderItems(results)}</Container>
            {renderPagination()}
            <Container>{renderSelections()}</Container>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
